var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoRecorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1668 12.6527C31.1668 11.7945 31.1668 11.3653 30.9971 11.1666C30.8499 10.9942 30.629 10.9027 30.4029 10.9205C30.1424 10.941 29.839 11.2444 29.2321 11.8513L24.0835 16.9999L29.2321 22.1485C29.839 22.7554 30.1424 23.0588 30.4029 23.0793C30.629 23.0971 30.8499 23.0056 30.9971 22.8332C31.1668 22.6345 31.1668 22.2054 31.1668 21.3471V12.6527Z",
    stroke: "#667085",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8335 13.8833C2.8335 11.503 2.8335 10.3129 3.29672 9.40379C3.70418 8.6041 4.35435 7.95394 5.15404 7.54647C6.06316 7.08325 7.25327 7.08325 9.6335 7.08325H17.2835C19.6637 7.08325 20.8538 7.08325 21.763 7.54647C22.5626 7.95394 23.2128 8.6041 23.6203 9.40379C24.0835 10.3129 24.0835 11.503 24.0835 13.8833V20.1166C24.0835 22.4968 24.0835 23.6869 23.6203 24.596C23.2128 25.3957 22.5626 26.0459 21.763 26.4534C20.8538 26.9166 19.6637 26.9166 17.2835 26.9166H9.6335C7.25327 26.9166 6.06316 26.9166 5.15404 26.4534C4.35435 26.0459 3.70418 25.3957 3.29672 24.596C2.8335 23.6869 2.8335 22.4968 2.8335 20.1166V13.8833Z",
    stroke: "#667085",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoRecorder);
export default __webpack_public_path__ + "static/media/video-recorder.dc41773ce7fa05ed484f3dcc03f06c83.svg";
export { ForwardRef as ReactComponent };